import assets from 'themes/base/assets';

export const LANGUAGE = {
  EN: 'en',
  DE: 'de',
  FR: 'fr',
};

export const LANGUAGES = [
  {
    code: LANGUAGE.EN, name: 'LANGUAGES.ENGLISH', image: assets.US, default: true,
  },
  {
    code: LANGUAGE.DE, name: 'LANGUAGES.GERMAN', image: assets.DE,
  },
  {
    code: LANGUAGE.FR, name: 'LANGUAGES.FRENCH', image: assets.FR,
  },
];
